import * as React from 'react';
import { useContext, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { AuthContext } from '../_auth/AuthContext';
import { FormControl, Grid, InputLabel, Select, MenuItem } from '@material-ui/core';
import { IPolicyObject, PolicyObjectTypeOptions } from '../_types/ewpolicy';
import { GetGroupPolicyObjects } from '../_service/ewpolicy';
import Policies from '../common/Policy/Policies';


interface Props {

};

const AdminPolicy: React.FC<Props> = (prop: Props) => {
    const { user } = useContext(AuthContext);

    const [groups,setGroups]=useState<IPolicyObject[] | null>(null);
    const [group,setGroup]=useState<IPolicyObject | null>(null);

    const useStyles = makeStyles((theme) => ({
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
          }
    }));
    const classes = useStyles();

    React.useEffect(() => {
        let grps = GetGroupPolicyObjects();
        let grp: IPolicyObject | undefined = grps.find(g => g.objectType == PolicyObjectTypeOptions.root);


        setGroups(grps);
        if (grp) setGroup(grp);

    },[])

    const SelectGroup = (opt: PolicyObjectTypeOptions) => {
        let grp: IPolicyObject | undefined = groups?.find(i => i.objectType === opt);
        if (grp) {
            setGroup(grp);
        }
    }

    return (
        <Grid container direction="column" justify="flex-start" alignItems="stretch" spacing={1}>
            {groups && (
            <Grid item>
                <FormControl className={classes.formControl}>
                    <InputLabel id="policy-group-select">Policy Group</InputLabel>
                    <Select
                    labelId="policy-group-select"
                    id="policy-select"
                    value={group!.objectType}
                    onChange={(e) => {SelectGroup(e.target.value as any)}}
                    >
                        {groups.map(g => (
                            <MenuItem value={g.objectType}>{g.displayName!}</MenuItem>
                        ))}
                        
                    </Select>
                </FormControl>
            </Grid>
            )}
            {group && (
                <Grid item>
                    <Policies policyObject={group} onChange={(e) => {}}></Policies>
                </Grid>
            )}
        </Grid>
    )
}

export default AdminPolicy;